import axiosInstance from './axios';

export const MARIA_TOKEN_QUERY_KEY = ['maria-token'] as const;

export const getMariaChatToken = (companyId: number) =>
  axiosInstance.post<{ token: string; businessId: string }>(`/companies/${companyId}/maria_token/`);
